import { render, staticRenderFns } from "./edit-declare-customsinfo.vue?vue&type=template&id=239c5b79"
import script from "./edit-declare-customsinfo.vue?vue&type=script&lang=ts"
export * from "./edit-declare-customsinfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports